///<reference types="chrome"/>
//// Remove chrome import
import { AfterViewInit, Component, OnInit, OnDestroy, ViewChild, EventEmitter } from '@angular/core';
import { Global } from "../../classes/global";
import { UserService } from "../../services/user/user.service";
import { Router, ActivatedRoute } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { NeedAuthorize } from "../../classes/needAuthorize";
import { SaleRecordService } from "../../services/saleRecord/sale-record.service";
import { MerchantService } from "../../services/merchant/merchant.service";
import { ToastrService } from 'ngx-toastr';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ElementRef } from '@angular/core';

import * as _ from 'lodash';
import { FulfillService } from '../../services/fulfill/fulfill.service';
import { ViewEncapsulation } from '@angular/core';

import { zenithProductsData } from './zenith-products';

import {
  HttpClient,
  HttpEventType,
  HttpErrorResponse
} from "@angular/common/http";
import { InventoryService } from '../../services/inventory/inventory.service';
import { TeroService } from '../../services/tero/tero.service';
import { Reference } from '@angular/compiler/src/render3/r3_ast';
import { UploadDesignService } from '../../services/upload-design/upload-design.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OrdersComponent extends NeedAuthorize implements AfterViewInit, OnDestroy {
  queryType: number = 1;
  availablePrintConfig: any;
  blueprints: [];
  onosProducts: [];
  gearmentProducts: any[] = [];
  gearmentVariants: any[]= [];
  teroProducts: any[] = [];
  teroSkusLoading: boolean = false;
  selectedTeroProduct: any = null;
  teroShippingTypes: string[] = ['TTS', 'TTSUK', 'MS', 'NS'];
  selectedTeroShippingType: string = null;
  availableCustomSkus: any[] = [];

  // VTP properties
  vtpMerchandise: any[] = [];
  vtpLineShipPrices: any[] = [];
  vtpLoading: boolean = false;
  selectedVtpMerchandise: any = null;
  selectedVtpLineShip: any = null;
  vtpMerchandiseSearch$ = new Subject<string>();
  private vtpMerchandiseSearchSubscription: Subscription;
  // Items users can pick for VTP. Keep in sync with VtpItemNamesBySku in FulfillApiController.cs.
  vtpItems: any[] = [
    { sku: 'T - SKU - 1866', name: 'T - HAT COTTON' },
  ];
  selectedVtpItem: any = null;
  vtpDimension = {
    weight: '',
    length: '',
    width: '',
    height: ''
  };

  // ISO properties (nhà in ISO chạy trên carrier ePacket)
  isoServices: { id: number, name: string }[] = [
    { id: 1,  name: 'Express Shipping' },
    { id: 2,  name: 'Epacket US (bao thuế)' },
    { id: 4,  name: 'Epacket WW' },
    { id: 9,  name: 'SINGPOST' },
    { id: 10, name: 'Lastmile Tracking' },
    { id: 11, name: 'Epacket Xanh' },
    { id: 12, name: 'Tiktok' },
    { id: 13, name: 'Tiktok By Seller' },
    { id: 15, name: 'Epacket Envelope' },
    { id: 16, name: 'Epacket Tiny' },
    { id: 19, name: 'TIKTOK_UK' },
    { id: 21, name: 'Epacket Eco' }
  ];
  isoOrderInput = {
    serviceId: '',
    packageName: '',
    orderItemName: '',
    length: '',
    width: '',
    height: '',
    weight: ''
  };
  selectedIsoService: any = null;

  // Printposs properties
  printpossVariants: any[] = [];
  printpossVariantsLoading: boolean = false;

  // HoGoToPod properties
  hogotopodProducts: any[] = [];
  hogotopodProductsLoading: boolean = false;
  selectedHoGoToPodProduct: any = null;
  availableHoGoToPodColors: any[] = [];
  availableHoGoToPodSizes: any[] = [];
  availableHoGoToPodPositions: any[] = [];

  query: any = {
    purchaseDate: '',
    shipDueDate: '',
    sourceOrderId: '',
    customerName: '',
    asin: '',
    sku: '',
    destinationOrderId: '',
    trackingNumber: '',
    note: '',
    merchantIds: '',
    merchantGroupIds: '',
    wantedPrintService: '',
    pageSize: 30,
    pageNumber: 1,
    sortBy: 'CreatedTime',
    sortType: 'Desc',
  };

  sellerCheck: any = {
    sourceImage: '',
    suggestProducts: [],
    destinationProductLinkText: "",
    downloadLink: [],
    availableDesigners: [],
    selectedDesigner: null
  };

  @ViewChild('uploadDesInput')
  uploadDesInput: ElementRef;

  saleRecords = [];
  totalItem = 0;
  merchants = [];
  tikTokMerchants = [];
  etsyMerchants = [];
  merchantGroups = [];
  uploadToMerchantGroupId = '';
  uploadToMerchantId = '';
  checkAll = false;
  sinceOrderId = '';

  printifyExport: any = {
    providerId: '',
    productId: ''
  }
  printifyProviders = [];
  printifyProducts = [];
  saleRecordLogs: any = [];
  quickFilters = [
    'isNeedFindLink',
    'isNeedSellerCheck',
    'isNeedFulfill',
    'isNeedShip',
    'isNeedAddTrackToAccount',
    'isFollowTrack',
    'isDone',
    'isNoticed',
  ];

  productLinkSaleRecord: any;
  deletedSaleRecord: any = {
    productName: ''
  };

  uploadImportFileProgress = 1;
  importMessages = [];

  temptPreviewImages = [];
  desImages = '';

  zenithProducts = [];

  atdLineOptions = [
    { label: 'Ship by Tiktok 2025', value: 'TK_2025' },
    { label: 'TikTok (ship by seller) 2025', value: 'TK_SBS_2025' },
    { label: 'TM ship by tiktok', value: 'TM_TK' },
    { label: 'TM ship by seller', value: 'TM_TK_SBS' },
    { label: 'Ship by seller bao thue', value: 'TK_SBS_BT' },
    { label: 'ship by tiktok bao thue', value: 'TK_BT' },
    { label: 'ship by seller VIP', value: 'TK_SBS_SVIP' },
  ];

  progressStates = [
    { name: 'Cần Seller Check', value: 0 },
    { name: 'Cần Xác Minh Thêm', value: 5 },
    { name: 'Cần Design', value: 10 },
    { name: 'Cần Fulfill', value: 20 },
    { name: 'Đợi Tracking', value: 30 },
    { name: 'Cần Trả Track TK', value: 35 },
    { name: 'Đang Theo Dõi Tracking', value: 40 },
    { name: 'Done', value: 50 },
  ];

  hdStikerProductNames = [
    'poster',
    'phone-case'

  ];

  filterCount: any = {

  };

  confirmBuyApiMessage = "";
  buyApiAction: any;

  @ViewChild('exportPrinityShirtModal', { static: false }) private exportPrinityShirtModal: NgbModalRef;
  @ViewChild('productLinkModal', { static: false }) private productLinkModal: NgbModalRef;
  @ViewChild('deleteSaleRecordModal', { static: false }) private deleteSaleRecordModal: NgbModalRef;
  @ViewChild('importSaleRecordModal', { static: false }) private importSaleRecordModal: NgbModalRef;
  @ViewChild('productLinkInput') productLinkInput: ElementRef;

  openConfirmBuyApiAction: EventEmitter<string> = new EventEmitter<string>();

  inventoryProducts: any[] = [];
  inventoryOutputLoading: boolean = false;
  inventoryOutputError: string = '';

  constructor(protected router: Router,
    protected userService: UserService,
    protected titleService: Title,
    public global: Global,
    private saleRecordService: SaleRecordService,
    private merchantService: MerchantService,
    private fulfillService: FulfillService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private activeRoute: ActivatedRoute,
    private http: HttpClient,
    private inventoryService: InventoryService,
    private teroService: TeroService,
    private uploadDesignService: UploadDesignService) {
    super(router, userService, titleService);

    this.activeRoute.queryParams.subscribe(params => {
      this.queryType = parseInt(params['queryType']);
      this.query.queryType = this.queryType;

      this.getMerchants();
      this.getMerchantGroups();
      //this.getPrintifyFulfillConfigs();
      this.querySaleRecords();
      this.getAvailablePrintConfigs();
      this.getBlueprints();
      this.getGearmentProducts();
      this.getPrintifyProviders();
      this.getAvailableOnosConfigs();

      this.setupZenithProducts();

    });
  }
  ngAfterViewInit(): void {
    
  }
  getAvailablePrintConfigs() {
    this.fulfillService.getAvailablePrintConfigs().subscribe
      (data => {
        this.availablePrintConfig = data;
      });
  }
  getAvailableOnosConfigs() {
    this.fulfillService.getAvailableOnosConfigs().subscribe
      (data => {
        this.onosProducts = data;
      });
  }

  ngOnInit(): void {
    this.inventoryProducts = [];
    this.inventoryOutputLoading = false;
    this.inventoryOutputError = '';
    // Load inventory products from server on init
    this.inventoryService.getProducts().subscribe({
      next: (products) => {
        this.inventoryProducts = products;
      },
      error: () => {
        this.inventoryProducts = [];
      }
    });

    // Setup VTP merchandise search with debouncing
    this.vtpMerchandiseSearchSubscription = this.vtpMerchandiseSearch$.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(searchTerm => {
      this.searchVtpMerchandise(searchTerm);
    });
  }

  public ngOnDestroy(): void {
    if (this.vtpMerchandiseSearchSubscription) {
      this.vtpMerchandiseSearchSubscription.unsubscribe();
    }
    this.vtpMerchandiseSearch$.complete();
  }

  preConfirmBuyApi(printService) {
    var checkRecordCount = 0;

    for (var i = 0; i < this.saleRecords.length; i++) {
      if (this.saleRecords[i].isSelected) {
        checkRecordCount++;
      }
    }

    this.confirmBuyApiMessage = "Bạn có muốn mua " + checkRecordCount + " bản ghi bằng " + printService + "?";
    if (printService == "flashship") {
      this.buyApiAction = this.buyMultipleRecordsByFlashshipApi;
    }

    if (printService == "bestPrintCare") {
      this.buyApiAction = this.buyMultipleRecordsByBestPrintCareApi;
    }

    if (printService == "monkeyKingPrint") {
      this.buyApiAction = this.buyMultipleRecordsByMonkeyKingPrintApi;
    }

    if (printService == "Onos") {
      this.buyApiAction = this.buyMultipleRecordsByOnosApi;
    }

    if (printService == "ISO") {
      this.buyApiAction = this.buyMultipleRecordsByIsoApi;
    }

    if (printService == "Printposs") {
      this.buyApiAction = this.buyMultipleRecordsByPrintpossApi;
    }

    if (printService == "Gearment") {
      this.buyApiAction = this.buyMultipleRecordsByGearmentApi;
    }

    if (printService == "ATD") {
      this.buyApiAction = this.buyMultipleRecordsByAtdApi;
    }

    if (printService == "Zenith") {
      this.buyApiAction = this.buyMultipleRecordsByZenithApi;
    }

    if (printService == "Hd Sticker") {
      this.buyApiAction = this.buyMultipleRecordsByHdStickerApi;
    }

    if (printService == "Tero") {
      this.buyApiAction = this.buyMultipleRecordsByTeroApi;
    }

    if (printService == "HoGoToPod") {
      this.buyApiAction = this.buyMultipleRecordsByHoGoToPodApi;
    }
    if (printService == "VTP") {
      this.buyApiAction = this.buyMultipleRecordsByVtpApi;
    }
    if (printService == "printify") {
      this.buyApiAction = this.buyMultipleRecordsByPrintifyApi;
    }
    
    this.openConfirmBuyApiAction.emit();
  }

  buyMultipleRecordsByFlashshipApi() {
    this.global.pageLoading = true;
    this.fulfillService.sendOrderFlashshipApi(this.saleRecords)
      .subscribe(data => {
          this.handleAfterSubmitApiOrders(data);
        },
        error => {
          this.toastr.error(error.message);
          this.global.pageLoading = false;
        });
  }

  buyMultipleRecordsByOnosApi() {
    this.global.pageLoading = true;
    this.fulfillService.sendOrderOnosApi(this.saleRecords)
      .subscribe(data => {
          this.handleAfterSubmitApiOrders(data);
        },
        error => {
          this.toastr.error(error.message);
          this.global.pageLoading = false;
        });
  }

  buyMultipleRecordsByIsoApi() {
    this.global.pageLoading = true;
    this.fulfillService.sendOrderIsoApi(this.saleRecords)
      .subscribe(data => {
          this.handleAfterSubmitApiOrders(data);
        },
        error => {
          this.toastr.error(error.message);
          this.global.pageLoading = false;
        });
  }

  buyMultipleRecordsByPrintpossApi() {
    this.global.pageLoading = true;
    this.fulfillService.sendOrderPrintpossApi(this.saleRecords)
      .subscribe(data => {
          this.handleAfterSubmitApiOrders(data);
        },
        error => {
          this.toastr.error(error.message);
          this.global.pageLoading = false;
        });
  }

  buyMultipleRecordsByGearmentApi() {
    this.global.pageLoading = true;
    this.fulfillService.sendOrderGearmentApi(this.saleRecords)
      .subscribe(data => {
          this.handleAfterSubmitApiOrders(data);
        },
        error => {
          this.toastr.error(error.message);
          this.global.pageLoading = false;
        });
  }

  buyMultipleRecordsByAtdApi() {
    this.global.pageLoading = true;
    this.fulfillService.sendOrderAtdApi(this.saleRecords)
      .subscribe(data => {
          this.handleAfterSubmitApiOrders(data);
        },
        error => {
          this.toastr.error(error.message);
          this.global.pageLoading = false;
        });
  }

  buyMultipleRecordsByZenithApi() {
    this.global.pageLoading = true;
    this.fulfillService.sendOrderZenithApi(this.saleRecords)
      .subscribe(data => {
        this.handleAfterSubmitApiOrders(data);
      },
      error => {
        this.toastr.error(error.message);
        this.global.pageLoading = false;
      });
  }

  buyMultipleRecordsByHdStickerApi() {
    this.global.pageLoading = true;
    this.fulfillService.sendOrderHdStickerApi(this.saleRecords)
      .subscribe(data => {
        this.handleAfterSubmitApiOrders(data);
      },
      error => {
        this.toastr.error(error.message);
        this.global.pageLoading = false;
      });
  }

  buyMultipleRecordsByBestPrintCareApi() {
    this.global.pageLoading = true;
    this.fulfillService.sendOrderBestPrintCareApi(this.saleRecords)
      .subscribe(data => {
        this.handleAfterSubmitApiOrders(data);
      },
      error => {
        this.toastr.error(error.message);
        this.global.pageLoading = false;
      });
  }

  buyMultipleRecordsByMonkeyKingPrintApi() {
    this.global.pageLoading = true;
    this.fulfillService.sendOrderToMonkeyKingPrintApi(this.saleRecords)
      .subscribe(data => {
          this.handleAfterSubmitApiOrders(data);
        },
        error => {
          this.toastr.error(error.message);
          this.global.pageLoading = false;
        });
  }

  buyMultipleRecordsByTeroApi() {
    this.global.pageLoading = true;
    this.fulfillService.sendOrderTeroApi(this.saleRecords)
      .subscribe(data => {
          this.handleAfterSubmitApiOrders(data);
        },
        error => {
          this.toastr.error(error.message);
          this.global.pageLoading = false;
        });
  }

  buyMultipleRecordsByHoGoToPodApi() {
    this.global.pageLoading = true;
    this.fulfillService.sendOrderHoGoToPodApi(this.saleRecords)
      .subscribe(data => {
          this.handleAfterSubmitApiOrders(data);
        },
        error => {
          this.toastr.error(error.message);
          this.global.pageLoading = false;
        });
  }

  buyMultipleRecordsByPrintifyApi() {
    this.global.pageLoading = true;
    this.fulfillService.sendOrderPrintifyApi(this.saleRecords)
      .subscribe(data => {
          this.handleAfterSubmitApiOrders(data);
        },
        error => {
          this.toastr.error(error.message);
          this.global.pageLoading = false;
        });
  }

  buyMultipleRecordsByVtpApi() {
    this.global.pageLoading = true;
    this.fulfillService.sendOrderVtpApi(this.saleRecords)
      .subscribe(data => {
          this.handleAfterSubmitApiOrders(data);
        },
        error => {
          this.toastr.error(error.message);
          this.global.pageLoading = false;
        });
  }

  handleAfterSubmitApiOrders(data) {
    this.refreshSaleRecordData(data);
    this.global.pageLoading = false;
    var hasError = false;
    for (var i = 0; i < data.length; i++) {
      if (!data[i]) {
        hasError = true;
        break;
      }
    }

    if (hasError) {
      this.toastr.error("Có lỗi xảy ra với một hoặc nhiều đơn");
    } else {
      this.toastr.success("Đơn đã được gửi sang hệ thống nhà in");
    }
  }

  refreshSaleRecordData(data: any) {
    for (var i = 0; i < this.saleRecords.length; i++) {

      for (var j = 0; j < data.length; j++) {
        if (!data[j]) {
          this.toastr.error("Có lỗi xảy ra với đơn mua api");
          continue;
        }
        if (data[j].orderItemId != this.saleRecords[i].orderItemId) {
          continue;
        }
        this.saleRecords[i] = data[j];
      }
    }

    this.global.pageLoading = false;
    this.getFilterCount();
    this.modalService.dismissAll();
  }

  clearFilter(isQueryAlso = true) {
    this.query = {
      purchaseDate: '',
      shipDueDate: '',
      sourceOrderId: '',
      customerName: '',
      asin: '',
      sku: '',
      destinationOrderId: '',
      trackingNumber: '',
      note: '',
      merchantIds: '',
      merchantGroupIds: '',
      pageSize: 30,
      pageNumber: 1,
      wantedPrintService: '',
      sortBy: 'CreatedTime',
      sortType: 'Desc',
    };

    for (var i = 0; i < this.quickFilters.length; i++) {
      var filter = this.quickFilters[i];
      this.query[filter] = false;
    }

    if (this.userData.roles.indexOf('Designer') > -1) {
      this.query.isNeedFindLink = true;
    }
    else if (this.userData.roles.indexOf('Fulfill') > -1) {
      this.query.isNeedFulfill = true;
      this.query.page = 60;
    }
    else if (this.userData.roles.indexOf('Support') > -1) {
      this.query.isNeedAddTrackToAccount = true;
    }

    if (isQueryAlso) {
      this.querySaleRecords();
    }
  }

  querySaleRecords(page = undefined) {
    if (page != undefined) {
      this.query.pageNumber = page;
    }
    this.global.pageLoading = true;
    this.saleRecordService.query(this.query).subscribe(data => {

      this.saleRecords = data.items;
      this.totalItem = data.total;

      this.global.pageLoading = false;
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

      this.filterCount = data.filterCount;
    });
  }

  getMerchants() {
    this.merchantService.getGrantedMerchants(this.query.merchantGroupIds).subscribe(data => {
      this.merchants = data;
      this.tikTokMerchants = data.filter(i => i.merchantType === 1);
      this.etsyMerchants = data.filter(i => i.merchantType === 7);
    });
  }

  getMerchantGroups() {
    this.merchantService.getGrantedMerchantGroups().subscribe(data => {
      this.merchantGroups = data;
    });
  }

  updateMerchantGroupFilter() {
    this.getMerchants();
    this.query.merchantIds = '';
    this.querySaleRecords(1);
  }

  updateSingleValue(record, type, value) {

    if (type == "Note") {
      record.note = value;
    }
    else if (type == "DestinationOrderId") {
      record.destinationOrderId = value;
    }
    else if (type == "ProductPrice") {
      record.productPrice = value;
    }
    else if (type == "OrderPrice") {
      record.orderPrice = value;
    }
    else if (type == "TrackingNumber") {
      record.trackingNumber = value;
    }
    else if (type == "OrderRefund") {
      record.orderRefund = value;
    }
    else if (type == "IsNeedReorder") {
      record.isNeedReorder = !record.isNeedReorder;
    }
    else if (type == "IsNeedFindLink") {
      record.isNeedFindLink = !record.isNeedFindLink;
    }
    else if (type == "IsCanceled") {
      record.isCanceled = !record.isCanceled;
    }
    else if (type == "IsNoticed") {
      record.isNoticed = !record.isNoticed;
    }
    else if (type == "IsDeleted") {
      record.isDeleted = value;
    }
    else if (type == "ProgressState") {
      record.progressState = value;
    }

    this.saleRecordService.updateSingleValue(record, type).subscribe(data => {
      for (var i = 0; i < this.saleRecords.length; i++) {

        var model = _.find(data, o => o.orderItemId === this.saleRecords[i].orderItemId);
        if (model == undefined || model.length === 0) {
          continue;
        }
        this.saleRecords[i] = model;

      }
      this.getFilterCount();
    });
  }

  getFilterCount() {
    this.saleRecordService.getFilterCount().subscribe(data => {
      this.filterCount = data;
    });
  }

  onCoppied(record, type) {
    for (var i = 0; i < this.saleRecords.length; i++) {
      this.saleRecords[i].sourceOrderIdCoppied = false;
      this.saleRecords[i].customerNameCoppied = false;
      this.saleRecords[i].asinCoppied = false;
      this.saleRecords[i].destinationOrderIdCoppied = false;
      this.saleRecords[i].productPriceCoppied = false;
      this.saleRecords[i].orderPriceCoppied = false;
      this.saleRecords[i].trackingNumberCoppied = false;
    }

    if (type === "sourceOrderId") {
      record.sourceOrderIdCoppied = true;
    }
    if (type === "customerName") {
      record.customerNameCoppied = true;
    }
    if (type === "asin") {
      record.asinCoppied = true;
    }
    if (type === "destinationOrderId") {
      record.destinationOrderIdCoppied = true;
    }
    if (type === "productPrice") {
      record.productPriceCoppied = true;
    }
    if (type === "orderPrice") {
      record.orderPriceCoppied = true;
    }
    if (type === "trackingNumber") {
      record.trackingNumberCoppied = true;
    }
  }

  reorder(record) {
    this.saleRecordService.reorder(record).subscribe((data) => {
      for (var i = 0; i < this.saleRecords.length; i++) {
        if (this.saleRecords[i].orderItemId != record.orderItemId) {
          continue;
        }

        this.saleRecords.splice(i, 0, data);
        record.isNeedReorder = false;
        break;
      }
    });
  }

  onProductLinkCopied() {
    this.toastr.success('copied');
    this.modalService.dismissAll();
  }

  saveProductLink() {
    this.updateSingleValue(this.productLinkSaleRecord, "ProductLink", this.productLinkSaleRecord.destinationProductLink);
    this.modalService.dismissAll();
  }

  confirmDeleteSaleRecord(record) {
    this.deletedSaleRecord = JSON.parse(JSON.stringify(record));
    this.modalService.open(this.deleteSaleRecordModal);
  }

  deleteSaleRecord() {
    this.updateSingleValue(this.deletedSaleRecord, "IsDeleted", true);
    this.modalService.dismissAll();
  }

  toggleQuickFilter(type) {

    for (var i = 0; i < this.quickFilters.length; i++) {
      var filter = this.quickFilters[i];
       if (filter == type) {
        this.query[filter] = !this.query[filter];
      } else if (this.quickFilters[i] == type) {
        this.query[filter] = true;
      } else {
        this.query[filter] = false;
      }
    }

    this.querySaleRecords();
  };

  getCustomization(customization, index) {
    if (customization == null || customization == '') {
      return '';
    }

    index = index - 1;

    var partSeperate = '';
    var informSeperate = '';
    if (customization.indexOf('====') > -1 || customization.indexOf('>>>') > -1) {
      partSeperate = '====';
      informSeperate = ">>>";
    } else {
      partSeperate = ',';
      informSeperate = ":";
    }

    var parts = customization.split(partSeperate);
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].split(informSeperate).length == 2) {
        parts[i] = parts[i].split(informSeperate)[1].trim();
      }
      else {
        parts[i] = parts[i].trim();
      }
    }
    if (index > parts.length - 1) {
      return '';
    }
    return parts[index];
  };

  copyOrderData(record) {
    if (record != undefined && (record.streetAddress2 == undefined || record.streetAddress2 == null)) {
      record.streetAddress2 = '';
    }
    let event = new CustomEvent('copySaleRecord', { 'detail': record });
    window.dispatchEvent(event);
  };

  copyHeading(record) {
    let str = 'ASIN: ' + record.asin;
    if (record.sku != undefined && record.sku != null && record.sku !== '') {
      let formatSkuParts = record.sku.split('-');

      if (formatSkuParts.length >= 2) {
        str += ' SKU: ' + formatSkuParts[0] + '-' + formatSkuParts[1];
      } else {
        str = ' SKU: ' + record.sku;
      }
    }
    this.copyStringToClipboard(str);
  };

  openExportPrintifyDialog() {
    this.printifyExport.providerId = '';
    this.printifyExport.productId = '';
    this.modalService.open(this.exportPrinityShirtModal);
  };

  downloadExportFileForPrintify() {
    this.global.pageLoading = true;
    this.modalService.dismissAll();
    this.fulfillService.downloadExportFileForPrintify(this.printifyExport, this.saleRecords).subscribe(data => {
      var blob = new Blob([data], { type: 'text/csv;charset=ASCII;' });
      var url = window.URL.createObjectURL(blob);
      this.global.pageLoading = false;

      var fileLink = document.createElement('a');
      fileLink.href = url;
      fileLink.download = "Export-printify.csv";
      fileLink.click();

      fileLink.parentNode.removeChild(fileLink);
    });
  };

  downloadExportFileForFlashship() {
    this.global.pageLoading = true;
    this.fulfillService.downloadExportFileForFlashship(this.saleRecords).subscribe(data => {
      var blob = new Blob([data], { type: 'text/csv;charset=ASCII;' });
      var url = window.URL.createObjectURL(blob);
      this.global.pageLoading = false;

      var fileLink = document.createElement('a');
      fileLink.href = url;
      fileLink.download = "Export-flash.csv";
      fileLink.click();

      fileLink.parentNode.removeChild(fileLink);
    });

  };

  downloadExportFileForBestPrintCare() {
    this.global.pageLoading = true;
    this.fulfillService.downloadExportFileForBestPrintCare(this.saleRecords).subscribe(data => {
      var blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      var url = window.URL.createObjectURL(blob);
      this.global.pageLoading = false;

      var fileLink = document.createElement('a');
      fileLink.href = url;
      fileLink.download = "Best-Print-Care.xlsx";
      fileLink.click();

      fileLink.parentNode.removeChild(fileLink);
    });
  };

  downloadExportFileForGke() {
    this.global.pageLoading = true;
    this.fulfillService.downloadExportFileForGke(this.saleRecords).subscribe(data => {
      var blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      var url = window.URL.createObjectURL(blob);
      this.global.pageLoading = false;

      var fileLink = document.createElement('a');
      fileLink.href = url;
      fileLink.download = "GKE.xlsx";
      fileLink.click();

      fileLink.parentNode.removeChild(fileLink);
    });
  };
    
  downloadExportFileForMerchize() {
      this.global.pageLoading = true;
      this.fulfillService.downloadExportFileForMerchize(this.saleRecords).subscribe(data => {
        var blob = new Blob([data], { type: 'text/csv;charset=ASCII;' });
        var url = window.URL.createObjectURL(blob);
        this.global.pageLoading = false;
  
        var fileLink = document.createElement('a');
        fileLink.href = url;
        fileLink.download = "Export-Merchize.csv";
        fileLink.click();
  
        fileLink.parentNode.removeChild(fileLink);
      });
    };

  copyStringToClipboard(str) {
    if (str === null || str === undefined || str === '') {
      str = ' ';
    }
    // Create new element
    var el = document.createElement('textarea');
    // Set value (string to be copied)
    el.value = str;
    // Set non-editable to avoid focus and move outside of view
    el.setAttribute('readonly', '');
    document.body.appendChild(el);
    // Select text inside element
    el.select();
    // Copy text to clipboard
    document.execCommand('copy');
    // Remove temporary element
    document.body.removeChild(el);
  };

  toggleCheckAll() {
    for (var i = 0; i < this.saleRecords.length; i++) {
      this.saleRecords[i].isSelected = !this.checkAll;
    }
  };

  openImportSaleRecordModal() {
    this.uploadImportFileProgress = 0;
    this.importMessages = [];
    this.uploadToMerchantGroupId = '';
    this.uploadToMerchantId = undefined;

    if (this.merchantGroups.length == 1) {
      this.uploadToMerchantGroupId = this.merchantGroups[0].id;
    }

    this.modalService.open(this.importSaleRecordModal, { windowClass: "xlModal" });
  }

  uploadImportFile(files) {
    if (this.uploadToMerchantGroupId == '') {
      return;
    }
    this.uploadImportFileProgress = 1;
    const formData = new FormData();

    for (var i = 0; i < files.length; i++) {
      formData.append("file", files[i]);
    }

    this.global.pageLoading = true;
    this.http
      .post("/api/SaleRecord/UploadSaleRecordsViaCsv?uploadToMerchantGroupId=" + this.uploadToMerchantGroupId
        + "&uploadToMerchantId=" + this.uploadToMerchantId,
        formData,
        {
          reportProgress: true,
          observe: "events"
        })
      .subscribe(event => {
        if (event.type == HttpEventType.UploadProgress) {
          this.uploadImportFileProgress = Math.round((100 / event.total) * event.loaded);

        } else if (event.type == HttpEventType.Response) {

          this.uploadImportFileProgress = null;
          this.global.pageLoading = false;

          this.importMessages = [];
          for (let i = 0; i < (<any>event.body).length; i++) {
            const element = event.body[i];
            this.importMessages.push(element.message);
          }
        }
      });
  }


  //Seller Check => Start
  openProductLinkModal(record) {
    this.global.pageLoading = true;
    this.saleRecordLogs = [];
    this.sellerCheck = {
      suggestProducts: [],
      destinationProductLinkText: "",
      selectedProduct: {
      },
      availableDesigners: [],
      selectedDesigner: null
    };
    this.temptPreviewImages = [];
    this.inventoryOutputLoading = false;
    this.inventoryOutputError = '';
    this.saleRecordService.getSellerCheckModel(record).subscribe(data => {
      this.sellerCheck = data;
      this.sellerCheck.currentRecord = record;

      if (this.sellerCheck.suggestProducts.length >= 1 && this.sellerCheck.sourceProduct.progressState >= 20) {
        this.selectSuggestProduct(this.sellerCheck.suggestProducts[0]);
      }

      if ((this.sellerCheck.selectedDesigner == null || this.sellerCheck.selectedDesigner == undefined)
        && this.sellerCheck.availableDesigners.length > 0) {
        this.sellerCheck.selectedDesigner = this.sellerCheck.availableDesigners[0];
      }

      this.modalService.open(this.productLinkModal, { windowClass: "xlModal" });
      this.genDownloadLinks();

      if (this.sellerCheck.sourceProduct.wantedPrintService == "Gearment") {
        var product = this.gearmentProducts.find(i => i.product_id === this.sellerCheck.calculatedGearmentProductId);
        this.gearmentVariants = product.variants;
      }

      if (this.sellerCheck.sourceProduct.wantedPrintService == "Tero") {
        this.loadTeroSkus();
      }

      if (this.sellerCheck.sourceProduct.wantedPrintService == "HoGoToPod") {
        this.loadHoGoToPodProducts();
      }

      if (this.sellerCheck.sourceProduct.wantedPrintService == "VTP") {
        this.loadVtpData();
      }

      if (this.sellerCheck.sourceProduct.wantedPrintService == "ISO") {
        this.loadIsoData();
      }

      if (this.sellerCheck.sourceProduct.wantedPrintService == "Printposs") {
        this.loadPrintpossVariants();
      }
      this.global.pageLoading = false;
    });

    this.saleRecordService.getSaleRecordLog(record).subscribe(data => {
      this.saleRecordLogs = data;
    });
  };

  selectSuggestProduct(suggestProduct) {
    this.sellerCheck.selectedProduct = suggestProduct;
    this.sellerCheck.destinationProductLinkText = suggestProduct.imageLinkText;
  };

  ignoreDes(suggestProduct) {
    suggestProduct.ignoredDes = true;
    this.saleRecordService.ignoreDes(suggestProduct.orderItemId).subscribe(data => { });
  }

  passToSeller() {
    var record = this.sellerCheck.currentRecord;

    this.global.pageLoading = true;
    record.destinationProductLink = this.sellerCheck.destinationProductLinkText;
    record.note = this.sellerCheck.sourceProduct.note;
    record.destinationProductThumbnail = this.sellerCheck?.selectedProduct?.demoLinks.join('\n') ?? '';
    record.progressState = 0;

    this.saleRecordService.update(record).subscribe(data => {

      for (var i = 0; i < this.saleRecords.length; i++) {

        if (data.orderItemId != this.saleRecords[i].orderItemId) {
          continue;
        }
        this.saleRecords[i] = data;
      }

      this.global.pageLoading = false;
      this.modalService.dismissAll();

      this.getFilterCount();
    });
  };

  passToNeedConfirm() {
    var record = this.sellerCheck.currentRecord;

    this.global.pageLoading = true;
    record.destinationProductLink = this.sellerCheck.destinationProductLinkText;
    record.note = this.sellerCheck.sourceProduct.note;
    record.destinationProductThumbnail = this.sellerCheck?.selectedProduct?.demoLinks.join('\n') ?? '';
    record.progressState = 5;

    this.saleRecordService.update(record).subscribe(data => {

      for (var i = 0; i < this.saleRecords.length; i++) {

        if (data.orderItemId != this.saleRecords[i].orderItemId) {
          continue;
        }
        this.saleRecords[i] = data;
      }

      this.global.pageLoading = false;
      this.getFilterCount();
      this.modalService.dismissAll();
    });
  };

  passToDesigner() {
    if (this.sellerCheck.selectedDesigner == null) {
      return;
    }
    var record = this.sellerCheck.currentRecord;

    this.global.pageLoading = true;
    record.destinationProductLink = this.sellerCheck.destinationProductLinkText;
    record.note = this.sellerCheck.sourceProduct.note;
    record.destinationProductThumbnail = this.sellerCheck?.selectedProduct?.demoLinks.join('\n') ?? '';
    record.progressState = 10;
    record.selectedDesignerId = this.sellerCheck.selectedDesigner.id;


    this.saleRecordService.update(record).subscribe(data => {

      for (var i = 0; i < this.saleRecords.length; i++) {

        if (data.orderItemId != this.saleRecords[i].orderItemId) {
          continue;
        }
        this.saleRecords[i] = data;
      }
      this.global.pageLoading = false;
      this.getFilterCount();
      this.modalService.dismissAll();
    });
  };

  passToFulfill() {
    if (this.sellerCheck.destinationProductLinkText == undefined
      || this.sellerCheck.destinationProductLinkText.trim() == '') {
      return;
    }
    var record = this.sellerCheck.currentRecord;

    this.global.pageLoading = true;
    record.destinationProductLink = this.sellerCheck.destinationProductLinkText;
    record.note = this.sellerCheck.sourceProduct.note;
    record.destinationProductThumbnail = this.sellerCheck.selectedProduct.demoLinks.join('\n');
    record.progressState = 20;

    this.saleRecordService.update(record).subscribe(data => {

      for (var i = 0; i < this.saleRecords.length; i++) {

        if (data.orderItemId != this.saleRecords[i].orderItemId) {
          continue;
        }
        this.saleRecords[i] = data;
      }

      this.global.pageLoading = false;
      this.getFilterCount();
      this.modalService.dismissAll();
    });
  };

  async upload(files) {
    this.sellerCheck.uploadProgress = 1;
    this.global.pageLoading = true;

    try {
      // Convert files to DesignFile objects for Dropbox upload
      const designFiles = Array.from(files).map((file: File, index: number) => {
        const positions: ('Front' | 'Back' | 'Left' | 'Right')[] = ['Front', 'Back', 'Left', 'Right'];
        return {
          file: file,
          position: positions[index] || 'Front'
        };
      });

      // Upload using the new Dropbox service
      const result = await this.uploadDesignService.uploadDesignFilesWithProgress(designFiles, (progress) => {
        this.sellerCheck.uploadProgress = progress;
      });

      this.sellerCheck.uploadProgress = null;
      this.global.pageLoading = false;
      this.sellerCheck.destinationProductLinkText = result.destinationProductLinkText;

      // Generate preview images from uploaded files
      this.temptPreviewImages = [];
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();
        
        reader.onload = (event: any) => {
          this.temptPreviewImages.push(event.target.result);
        };
        
        reader.readAsDataURL(file);
      }

      this.sellerCheck.selectedProduct = {
        demoLinks: result.previewImages
      };

      this.genDownloadLinks();
      this.desImages = '';

    } catch (error) {
      console.error('Upload error:', error);
      alert('Có lỗi xảy ra, xin thử lại');
      this.sellerCheck.uploadProgress = null;
      this.global.pageLoading = false;
      this.desImages = '';
    }
  };

  genDownloadLinks() {
    this.sellerCheck.downloadLinks = [];
    var text = this.sellerCheck.destinationProductLinkText;
    if (text == undefined || text == '') {
      return;
    }
    var parts = text.split('\n');
    for (let i = 0; i < parts.length; i++) {
      const element = parts[i];
      var downloadLink = element.replace('raw=', 'dl=');
      this.sellerCheck.downloadLinks.push(downloadLink);
    }
  }

  genSellerCheckCustomizeInfo(customization) {

    var result = [];
    for (let i = 1; i < 20; i++) {
      var customizeInfoPart = this.getCustomization(customization, i);
      if (customizeInfoPart != undefined && customizeInfoPart != '') {
        result.push(customizeInfoPart);
        continue;
      }
      break
    }
    return result.join(' | ');
  }

  syncSellerCheckPrice(record, type) {
    if (type == 'orderPrice' && record.orderPrice > 0) {
      record.productPrice = 0;
    }
    if (type == 'productPrice' && record.productPrice > 0) {
      record.orderPrice = 0;
    }

  }

  confirmBuy() {
    if (this.sellerCheck.sourceProduct.destinationOrderId == undefined
      || this.sellerCheck.sourceProduct.destinationOrderId.trim() == ''
      || (this.sellerCheck.sourceProduct.productPrice == 0 && this.sellerCheck.sourceProduct.orderPrice == 0)) {
      return;
    }
    var record = this.sellerCheck.currentRecord;

    this.global.pageLoading = true;

    record.note = this.sellerCheck.sourceProduct.note;
    record.destinationOrderId = this.sellerCheck.sourceProduct.destinationOrderId;
    record.destinationProductLink = this.sellerCheck.destinationProductLinkText;
    record.productPrice = this.sellerCheck.sourceProduct.productPrice;
    record.orderPrice = this.sellerCheck.sourceProduct.orderPrice;
    record.progressState = 30;

    this.saleRecordService.update(record).subscribe(data => {

      for (var i = 0; i < this.saleRecords.length; i++) {

        var model = _.find(data, o => o.orderItemId === this.saleRecords[i].orderItemId);
        if (model == undefined || model.length === 0) {
          continue;
        }
        this.saleRecords[i] = model;

      }

      this.global.pageLoading = false;
      this.getFilterCount();
      this.modalService.dismissAll();
    });
  }

  confirmTracking() {
    if (this.sellerCheck.sourceProduct.trackingNumber == 0) {
      return;
    }
    var record = this.sellerCheck.currentRecord;

    this.global.pageLoading = true;

    record.note = this.sellerCheck.sourceProduct.note;
    record.trackingNumber = this.sellerCheck.sourceProduct.trackingNumber;
    record.progressState = 35;

    this.saleRecordService.update(record).subscribe(data => {

      for (var i = 0; i < this.saleRecords.length; i++) {

        var model = _.find(data, o => o.orderItemId === this.saleRecords[i].orderItemId);
        if (model == undefined || model.length === 0) {
          continue;
        }
        this.saleRecords[i] = model;

      }

      this.global.pageLoading = false;
      this.getFilterCount();
      this.modalService.dismissAll();
    });
  }

  confirmTrackingAccount() {

    var record = this.sellerCheck.currentRecord;

    this.global.pageLoading = true;

    record.note = this.sellerCheck.sourceProduct.note;
    record.progressState = 40;

    this.saleRecordService.update(record).subscribe(data => {

      for (var i = 0; i < this.saleRecords.length; i++) {

        var model = _.find(data, o => o.orderItemId === this.saleRecords[i].orderItemId);
        if (model == undefined || model.length === 0) {
          continue;
        }
        this.saleRecords[i] = model;

      }

      this.global.pageLoading = false;
      this.getFilterCount();
      this.modalService.dismissAll();
    });
  }

  confirmTrackingDone() {
    if (this.sellerCheck.sourceProduct.trackingNumber == 0) {
      return;
    }
    var record = this.sellerCheck.currentRecord;

    this.global.pageLoading = true;

    record.note = this.sellerCheck.sourceProduct.note;
    record.progressState = 50;

    this.saleRecordService.update(record).subscribe(data => {

      for (var i = 0; i < this.saleRecords.length; i++) {

        var model = _.find(data, o => o.orderItemId === this.saleRecords[i].orderItemId);
        if (model == undefined || model.length === 0) {
          continue;
        }
        this.saleRecords[i] = model;

      }

      this.global.pageLoading = false;
      this.getFilterCount();
      this.modalService.dismissAll();
    });
  }

  updatePrintService(orderItemId, wantedPrintService) {
    this.saleRecordService.updatePrintService(orderItemId, wantedPrintService)
      .subscribe(data => {
        for (var i = 0; i < this.saleRecords.length; i++) {

          if (orderItemId != this.saleRecords[i].orderItemId) {
            continue;
          }
          this.saleRecords[i].wantedPrintService = wantedPrintService;
        }

        // Load Tero SKUs if Tero is selected
        if (wantedPrintService == "Tero") {
          this.loadTeroSkus();
        }

        // Seed ISO inputs when switching to ISO
        if (wantedPrintService == "ISO") {
          this.loadIsoData();
        }
      });
  }

  loadTeroSkus() {
    this.teroSkusLoading = true;
    this.teroService.getAllProductSkus().subscribe({
      next: (data) => {
        if (data && data.products) {
          this.teroProducts = data.products;
          console.log('Loaded Tero products:', this.teroProducts.length);
          
          // Set the selected Tero SKU if it exists
          if (this.sellerCheck.calculatedTeroSku) {
            this.setSelectedTeroSku(this.sellerCheck.calculatedTeroSku);
          }
          
          // Set the selected Tero shipping type if it exists
          if (this.sellerCheck.calculatedTeroShippingType) {
            this.setSelectedTeroShippingType(this.sellerCheck.calculatedTeroShippingType);
          }
          
          // Set the selected custom SKU if it exists
          if (this.sellerCheck.calculatedTeroCustomSku) {
            console.log('Setting selected custom SKU:', this.sellerCheck.calculatedTeroCustomSku);
          }
        }
        this.teroSkusLoading = false;
      },
      error: (error) => {
        console.error('Error loading Tero SKUs:', error);
        this.teroSkusLoading = false;
        this.toastr.error('Failed to load Tero products', 'Error');
      }
    });
  }

  onTeroProductSelected(selectedProduct: any) {
    if (selectedProduct && selectedProduct.sku) {
      this.selectedTeroProduct = selectedProduct;
      // Update variant info with TeroSku key
      this.updateVariantInfo(this.sellerCheck.sourceProduct.orderItemId, 'TeroSku', selectedProduct.sku);
      console.log('Selected Tero product:', selectedProduct.sku);
      
      // Populate available custom SKUs from the selected product variants
      this.updateAvailableCustomSkus();
    }
  }

  setSelectedTeroSku(teroSku: string) {
    if (this.teroProducts && this.teroProducts.length > 0) {
      this.selectedTeroProduct = this.teroProducts.find(product => product.sku === teroSku);
      console.log('Set selected Tero product:', this.selectedTeroProduct);
      
      // Update available custom SKUs when setting selected product
      this.updateAvailableCustomSkus();
    }
  }

  onTeroShippingTypeSelected(selectedShippingType: string) {
    if (selectedShippingType) {
      // Update variant info with TeroShippingType key
      this.updateVariantInfo(this.sellerCheck.sourceProduct.orderItemId, 'TeroShippingType', selectedShippingType);
      console.log('Selected Tero shipping type:', selectedShippingType);
    }
  }

  setSelectedTeroShippingType(teroShippingType: string) {
    this.selectedTeroShippingType = teroShippingType;
    console.log('Set selected Tero shipping type:', this.selectedTeroShippingType);
  }

  updateAvailableCustomSkus() {
    this.availableCustomSkus = [];
    if (this.selectedTeroProduct && this.selectedTeroProduct.variants) {
      // Create a map to track unique custom_sku values
      const uniqueSkus = new Map();
      
      this.selectedTeroProduct.variants.forEach(variant => {
        if (!uniqueSkus.has(variant.custom_sku)) {
          uniqueSkus.set(variant.custom_sku, {
            ...variant,
            displayText: `${variant.custom_sku}`
          });
        }
      });
      
      this.availableCustomSkus = Array.from(uniqueSkus.values());
      console.log('Updated available custom SKUs:', this.availableCustomSkus.length);
    }
  }

  onCustomSkuSelected(selectedCustomSku: any) {
    if (selectedCustomSku) {
      // Update variant info with CalculatedTeroCustomSku key
      this.updateVariantInfo(this.sellerCheck.sourceProduct.orderItemId, 'CalculatedTeroCustomSku', selectedCustomSku.custom_sku);
      console.log('Selected custom SKU:', selectedCustomSku);
    }
  }

  // VTP helpers
  // ISO helpers
  loadIsoData() {
    // Pre-fill from existing customizeInfo if any
    const ciMap = this.parseCustomInfoMap(this.sellerCheck.sourceProduct.customizeInfo);
    this.isoOrderInput.serviceId     = ciMap['IsoServiceId']     || '';
    this.isoOrderInput.packageName   = ciMap['IsoPackageName']   || '';
    this.isoOrderInput.orderItemName = ciMap['IsoOrderItemName'] || '';
    this.isoOrderInput.length        = ciMap['IsoLength']        || '';
    this.isoOrderInput.width         = ciMap['IsoWidth']         || '';
    this.isoOrderInput.height        = ciMap['IsoHeight']        || '';
    this.isoOrderInput.weight        = ciMap['IsoWeight']        || '';
    this.selectedIsoService = this.isoServices.find(s => String(s.id) === this.isoOrderInput.serviceId) || null;
  }

  onIsoServiceSelected(service: any) {
    const id = service ? service.id : '';
    this.isoOrderInput.serviceId = id != null ? String(id) : '';
    this.updateVariantInfo(this.sellerCheck.sourceProduct.orderItemId, 'IsoServiceId', this.isoOrderInput.serviceId);
  }

  onIsoFieldChanged(field: 'packageName' | 'orderItemName' | 'length' | 'width' | 'height' | 'weight') {
    const key =
      field === 'packageName'   ? 'IsoPackageName'   :
      field === 'orderItemName' ? 'IsoOrderItemName' :
      field === 'length'        ? 'IsoLength'        :
      field === 'width'         ? 'IsoWidth'         :
      field === 'height'        ? 'IsoHeight'        : 'IsoWeight';
    this.updateVariantInfo(this.sellerCheck.sourceProduct.orderItemId, key, this.isoOrderInput[field]);
  }

  loadVtpData() {
    this.vtpLoading = true;

    // Pre-fill from existing customizeInfo if any
    const ciMap = this.parseCustomInfoMap(this.sellerCheck.sourceProduct.customizeInfo);
    this.vtpDimension.weight = ciMap['VtpWeight'] || '';
    this.vtpDimension.length = ciMap['VtpLength'] || '';
    this.vtpDimension.width  = ciMap['VtpWidth']  || '';
    this.vtpDimension.height = ciMap['VtpHeight'] || '';

    this.selectedVtpItem = this.vtpItems.find(i => i.sku === ciMap['VtpItemSku']) || null;

    const merchId = ciMap['VtpMerchandiseId'] || '';
    const merchCode = ciMap['VtpMerchandiseCode'] || '';
    const lineShipId = ciMap['VtpLineShipId'] || '';
    const lineShipName = ciMap['VtpLineShipName'] || '';

    // Load merchandise from Fulfill API (now static server-side)
    this.fulfillService.getVtpMerchandise('', 50, 0).subscribe({
      next: (resp) => {
        this.vtpMerchandise = resp?.data?.items || [];
        if (merchId) {
          this.selectedVtpMerchandise =
            this.vtpMerchandise.find(i => i.id === merchId) ||
            this.vtpMerchandise.find(i => i.code === merchCode) ||
            { id: merchId, code: merchCode, name: merchCode };
        }
        this.vtpLoading = false;
      },
      error: () => { this.vtpLoading = false; }
    });

    // Load line ship list from Fulfill API (now static server-side)
    this.refreshVtpLineShipPrice(lineShipId, lineShipName);
  }

  refreshVtpLineShipPrice(preselectLineShipId?: string, preselectLineShipName?: string) {
    const weight = parseFloat(this.vtpDimension.weight) || 1;
    const length = parseFloat(this.vtpDimension.length) || 1;
    const width  = parseFloat(this.vtpDimension.width)  || 1;
    const height = parseFloat(this.vtpDimension.height) || 1;

    const body = {
      from: 'VN',
      to: 'US',
      parcel: {
        weight,
        length,
        width,
        height,
        lengthUnit: 1,
        weightUnit: 3
      }
    };

    this.fulfillService.getVtpLineShipPrice(body).subscribe({
      next: (resp) => {
        this.vtpLineShipPrices = resp?.data || [];
        const foundById = preselectLineShipId
          ? this.vtpLineShipPrices.find(i => i.lineShipId === preselectLineShipId)
          : null;
        const foundByName = !foundById && preselectLineShipName
          ? this.vtpLineShipPrices.find(i => i.lineShipName?.toLowerCase() === preselectLineShipName.toLowerCase())
          : null;
        if (foundById || foundByName) {
          this.selectedVtpLineShip = foundById || foundByName;
        } else if (preselectLineShipId || preselectLineShipName) {
          const seeded = {
            lineShipId: preselectLineShipId,
            lineShipName: preselectLineShipName,
          };
          this.vtpLineShipPrices.push(seeded);
          this.selectedVtpLineShip = seeded;
        }
      },
      error: () => {
        this.vtpLineShipPrices = [];
      }
    });
  }

  onVtpMerchandiseSelected(item: any) {
    if (!item) {
      return;
    }
    // item can be id or object depending on ng-select
    let merch = item;
    if (typeof item === 'string') {
      merch = this.vtpMerchandise.find(m => m.id === item) || { id: item };
    }
    this.selectedVtpMerchandise = merch;
    this.updateVariantInfo(this.sellerCheck.sourceProduct.orderItemId, 'VtpMerchandiseCode', merch.code || '');
  }

  onVtpItemSelected(item: any) {
    this.selectedVtpItem = item || null;
    this.updateVariantInfo(this.sellerCheck.sourceProduct.orderItemId, 'VtpItemSku', item ? item.sku : '');
  }

  onVtpMerchandiseSearch(event: any) {
    // Handle both object format { term: string } and direct string
    const searchTerm = typeof event === 'string' ? event : (event?.term || '');
    this.vtpMerchandiseSearch$.next(searchTerm);
  }

  searchVtpMerchandise(searchTerm: string) {
    this.vtpLoading = true;
    this.fulfillService.getVtpMerchandise(searchTerm || '', 50, 0).subscribe({
      next: (resp) => {
        this.vtpMerchandise = resp?.data?.items || [];
        this.vtpLoading = false;
      },
      error: () => { this.vtpLoading = false; }
    });
  }

  onVtpLineShipSelected(item: any) {
    if (!item) {
      return;
    }
    let lineShip = item;
    if (typeof item === 'string') {
      lineShip = this.vtpLineShipPrices.find(l => l.lineShipId === item) || { lineShipId: item };
    }
    this.selectedVtpLineShip = lineShip;
    this.updateVariantInfo(this.sellerCheck.sourceProduct.orderItemId, 'VtpLineShipId', lineShip.lineShipId || '');
    this.updateVariantInfo(this.sellerCheck.sourceProduct.orderItemId, 'VtpLineShipName', lineShip.lineShipName || '');
  }

  onVtpDimensionChanged(field?: 'weight' | 'length' | 'width' | 'height') {
    // Only update the dimension that changed (for lighter updates), fallback to all if not specified
    const fieldsToUpdate = field ? [field] : ['weight', 'length', 'width', 'height'];

    fieldsToUpdate.forEach(f => {
      const key =
        f === 'weight' ? 'VtpWeight' :
        f === 'length' ? 'VtpLength' :
        f === 'width'  ? 'VtpWidth'  : 'VtpHeight';
      const value = this.vtpDimension[f];
      this.updateVariantInfo(this.sellerCheck.sourceProduct.orderItemId, key, value);
    });
    this.refreshVtpLineShipPrice(this.selectedVtpLineShip?.lineShipId);
  }

  private parseCustomInfoMap(customizeInfo: string): { [key: string]: string } {
    const map: { [key: string]: string } = {};
    if (!customizeInfo || typeof customizeInfo !== 'string') {
      return map;
    }
    const parts = customizeInfo.split('====').filter(p => p.includes('>>>'));
    parts.forEach(p => {
      const [k, v] = p.split('>>>');
      if (k && v !== undefined) {
        map[k.trim()] = v.trim();
      }
    });
    return map;
  }

  updateFulfillLabelPrice(orderItemId, fulfillLabelPrice) {
    this.sellerCheck.sourceProduct.orderPrice = this.sellerCheck.sourceProduct.orderPrice + fulfillLabelPrice;
    this.sellerCheck.calculatedFulfillLabelPrice = 0;
    this.updateSingleValue(this.sellerCheck.sourceProduct, 'OrderPrice', this.sellerCheck.sourceProduct.orderPrice);
  }

  onAddCustomSize(event: any) {
    // Handle both string and object formats from ng-select addTag event
    const customSize = typeof event === 'string' ? event : (event?.value || event?.term || event);
    
    if (!customSize || (typeof customSize === 'string' && customSize.trim() === '')) {
      return;
    }
    
    const sizeValue = typeof customSize === 'string' ? customSize.trim() : customSize.toString().trim();
    
    // Check if size already exists
    const sizeExists = this.sellerCheck.availableSizes && 
      this.sellerCheck.availableSizes.some(size => {
        const existingSize = typeof size === 'string' ? size : (size?.toString() || size);
        return existingSize === sizeValue;
      });
    
    if (!sizeExists) {
      // Add the custom size to the available sizes list
      if (!this.sellerCheck.availableSizes) {
        this.sellerCheck.availableSizes = [];
      }
      this.sellerCheck.availableSizes.push(sizeValue);
      
      // Set the selected size to the newly added custom size
      this.sellerCheck.calculatedSize = sizeValue;
      
      // Update variant info with the custom size
      this.updateVariantInfo(this.sellerCheck.sourceProduct.orderItemId, 'size', sizeValue);
    } else {
      // If it already exists, just select it
      this.sellerCheck.calculatedSize = sizeValue;
      this.updateVariantInfo(this.sellerCheck.sourceProduct.orderItemId, 'size', sizeValue);
    }
  }

  onSizeChange(selectedSize: any) {
    // Handle both string and object formats
    const sizeValue = typeof selectedSize === 'string' ? selectedSize : (selectedSize?.toString() || selectedSize);
    this.updateVariantInfo(this.sellerCheck.sourceProduct.orderItemId, 'size', sizeValue);
  }

  updateVariantInfo(orderItemId, type, value, onDone?: () => void) {
    this.saleRecordService.updateVariantInfo(orderItemId, type, value)
      .subscribe(data => {
        if (onDone) {
          onDone();
        }

        for (var i = 0; i < this.saleRecords.length; i++) {

          if (orderItemId != this.saleRecords[i].orderItemId) {
            continue;
          }

          this.saleRecords[i].customizeInfo = data;
        }

        if (this.sellerCheck?.sourceProduct?.orderItemId === orderItemId) {
          this.sellerCheck.sourceProduct.customizeInfo = data;
        }
      });
  }

  // Printposs methods
  // API GetPrintpossProducts không ổn định nên hard code danh sách SKU (AirPods Case, product id 3).
  // Khi Printposs có thêm sản phẩm/SKU mới, thêm entry vào đây (id có thể bỏ trống, backend resolve theo sku).
  printpossVariantsStatic: any[] = [
    { id: 106, sku: 'apsb-ap1-wht', label: 'AirPods Case - AirPods 1 (apsb-ap1-wht)' },
    { id: 107, sku: 'apsb-ap2-wht', label: 'AirPods Case - AirPods 2 (apsb-ap2-wht)' },
    { id: 108, sku: 'apsb-ap3-wht', label: 'AirPods Case - AirPods 3 (apsb-ap3-wht)' },
    { id: 109, sku: 'apsb-ap4-wht', label: 'AirPods Case - AirPods 4 (apsb-ap4-wht)' },
    { id: 110, sku: 'apsb-app-wht', label: 'AirPods Case - AirPods Pro 1 (apsb-app-wht)' },
    { id: 111, sku: 'apsb-app2-wht', label: 'AirPods Case - AirPods Pro 2 (apsb-app2-wht)' },
    { id: 112, sku: 'apsb-app3-wht', label: 'AirPods Case - AirPods Pro 3 (apsb-app3-wht)' },
    // Tough Case 2n1 / MagSafe Tough Case 2n1 (iPhone): chưa có id, backend resolve variant theo sku qua catalog.
    { sku: 'tgh2n1sb-ip11-wht', label: 'Tough Case 2n1 - iPhone 11 (tgh2n1sb-ip11-wht)' },
    { sku: 'mstgh2n1sb-ip11-wht', label: 'MagSafe Tough Case 2n1 - iPhone 11 (mstgh2n1sb-ip11-wht)' },
    { sku: 'tgh2n1sb-ip11pr-wht', label: 'Tough Case 2n1 - iPhone 11 Pro (tgh2n1sb-ip11pr-wht)' },
    { sku: 'mstgh2n1sb-ip11pr-wht', label: 'MagSafe Tough Case 2n1 - iPhone 11 Pro (mstgh2n1sb-ip11pr-wht)' },
    { sku: 'tgh2n1sb-ip11prm-wht', label: 'Tough Case 2n1 - iPhone 11 Pro Max (tgh2n1sb-ip11prm-wht)' },
    { sku: 'mstgh2n1sb-ip11prm-wht', label: 'MagSafe Tough Case 2n1 - iPhone 11 Pro Max (mstgh2n1sb-ip11prm-wht)' },
    { sku: 'tgh2n1sb-ip12mn-wht', label: 'Tough Case 2n1 - iPhone 12 mini (tgh2n1sb-ip12mn-wht)' },
    { sku: 'mstgh2n1sb-ip12mn-wht', label: 'MagSafe Tough Case 2n1 - iPhone 12 mini (mstgh2n1sb-ip12mn-wht)' },
    { sku: 'tgh2n1sb-ip12-wht', label: 'Tough Case 2n1 - iPhone 12 (tgh2n1sb-ip12-wht)' },
    { sku: 'mstgh2n1sb-ip12-wht', label: 'MagSafe Tough Case 2n1 - iPhone 12 (mstgh2n1sb-ip12-wht)' },
    { sku: 'tgh2n1sb-ip12pr-wht', label: 'Tough Case 2n1 - iPhone 12 Pro (tgh2n1sb-ip12pr-wht)' },
    { sku: 'mstgh2n1sb-ip12pr-wht', label: 'MagSafe Tough Case 2n1 - iPhone 12 Pro (mstgh2n1sb-ip12pr-wht)' },
    { sku: 'tgh2n1sb-ip12prm-wht', label: 'Tough Case 2n1 - iPhone 12 Pro Max (tgh2n1sb-ip12prm-wht)' },
    { sku: 'mstgh2n1sb-ip12prm-wht', label: 'MagSafe Tough Case 2n1 - iPhone 12 Pro Max (mstgh2n1sb-ip12prm-wht)' },
    { sku: 'tgh2n1sb-ip13mn-wht', label: 'Tough Case 2n1 - iPhone 13 mini (tgh2n1sb-ip13mn-wht)' },
    { sku: 'mstgh2n1sb-ip13mn-wht', label: 'MagSafe Tough Case 2n1 - iPhone 13 mini (mstgh2n1sb-ip13mn-wht)' },
    { sku: 'tgh2n1sb-ip13-wht', label: 'Tough Case 2n1 - iPhone 13 (tgh2n1sb-ip13-wht)' },
    { sku: 'mstgh2n1sb-ip13-wht', label: 'MagSafe Tough Case 2n1 - iPhone 13 (mstgh2n1sb-ip13-wht)' },
    { sku: 'tgh2n1sb-ip13pr-wht', label: 'Tough Case 2n1 - iPhone 13 Pro (tgh2n1sb-ip13pr-wht)' },
    { sku: 'mstgh2n1sb-ip13pr-wht', label: 'MagSafe Tough Case 2n1 - iPhone 13 Pro (mstgh2n1sb-ip13pr-wht)' },
    { sku: 'tgh2n1sb-ip13prm-wht', label: 'Tough Case 2n1 - iPhone 13 Pro Max (tgh2n1sb-ip13prm-wht)' },
    { sku: 'mstgh2n1sb-ip13prm-wht', label: 'MagSafe Tough Case 2n1 - iPhone 13 Pro Max (mstgh2n1sb-ip13prm-wht)' },
    { sku: 'tgh2n1sb-ip14-wht', label: 'Tough Case 2n1 - iPhone 14 (tgh2n1sb-ip14-wht)' },
    { sku: 'mstgh2n1sb-ip14-wht', label: 'MagSafe Tough Case 2n1 - iPhone 14 (mstgh2n1sb-ip14-wht)' },
    { sku: 'tgh2n1sb-ip14pl-wht', label: 'Tough Case 2n1 - iPhone 14 Plus (tgh2n1sb-ip14pl-wht)' },
    { sku: 'mstgh2n1sb-ip14pl-wht', label: 'MagSafe Tough Case 2n1 - iPhone 14 Plus (mstgh2n1sb-ip14pl-wht)' },
    { sku: 'tgh2n1sb-ip14pr-wht', label: 'Tough Case 2n1 - iPhone 14 Pro (tgh2n1sb-ip14pr-wht)' },
    { sku: 'mstgh2n1sb-ip14pr-wht', label: 'MagSafe Tough Case 2n1 - iPhone 14 Pro (mstgh2n1sb-ip14pr-wht)' },
    { sku: 'tgh2n1sb-ip14prm-wht', label: 'Tough Case 2n1 - iPhone 14 Pro Max (tgh2n1sb-ip14prm-wht)' },
    { sku: 'mstgh2n1sb-ip14prm-wht', label: 'MagSafe Tough Case 2n1 - iPhone 14 Pro Max (mstgh2n1sb-ip14prm-wht)' },
    { sku: 'tgh2n1sb-ip15-wht', label: 'Tough Case 2n1 - iPhone 15 (tgh2n1sb-ip15-wht)' },
    { sku: 'mstgh2n1sb-ip15-wht', label: 'MagSafe Tough Case 2n1 - iPhone 15 (mstgh2n1sb-ip15-wht)' },
    { sku: 'tgh2n1sb-ip15pl-wht', label: 'Tough Case 2n1 - iPhone 15 Plus (tgh2n1sb-ip15pl-wht)' },
    { sku: 'mstgh2n1sb-ip15pl-wht', label: 'MagSafe Tough Case 2n1 - iPhone 15 Plus (mstgh2n1sb-ip15pl-wht)' },
    { sku: 'tgh2n1sb-ip15pr-wht', label: 'Tough Case 2n1 - iPhone 15 Pro (tgh2n1sb-ip15pr-wht)' },
    { sku: 'mstgh2n1sb-ip15pr-wht', label: 'MagSafe Tough Case 2n1 - iPhone 15 Pro (mstgh2n1sb-ip15pr-wht)' },
    { sku: 'tgh2n1sb-ip15prm-wht', label: 'Tough Case 2n1 - iPhone 15 Pro Max (tgh2n1sb-ip15prm-wht)' },
    { sku: 'mstgh2n1sb-ip15prm-wht', label: 'MagSafe Tough Case 2n1 - iPhone 15 Pro Max (mstgh2n1sb-ip15prm-wht)' },
    { sku: 'tgh2n1sb-ip16-wht', label: 'Tough Case 2n1 - iPhone 16 (tgh2n1sb-ip16-wht)' },
    { sku: 'mstgh2n1sb-ip16-wht', label: 'MagSafe Tough Case 2n1 - iPhone 16 (mstgh2n1sb-ip16-wht)' },
    { sku: 'tgh2n1sb-ip16pl-wht', label: 'Tough Case 2n1 - iPhone 16 Plus (tgh2n1sb-ip16pl-wht)' },
    { sku: 'mstgh2n1sb-ip16pl-wht', label: 'MagSafe Tough Case 2n1 - iPhone 16 Plus (mstgh2n1sb-ip16pl-wht)' },
    { sku: 'tgh2n1sb-ip16pr-wht', label: 'Tough Case 2n1 - iPhone 16 Pro (tgh2n1sb-ip16pr-wht)' },
    { sku: 'mstgh2n1sb-ip16pr-wht', label: 'MagSafe Tough Case 2n1 - iPhone 16 Pro (mstgh2n1sb-ip16pr-wht)' },
    { sku: 'tgh2n1sb-ip16prm-wht', label: 'Tough Case 2n1 - iPhone 16 Pro Max (tgh2n1sb-ip16prm-wht)' },
    { sku: 'mstgh2n1sb-ip16prm-wht', label: 'MagSafe Tough Case 2n1 - iPhone 16 Pro Max (mstgh2n1sb-ip16prm-wht)' },
    { sku: 'tgh2n1sb-ip16e-wht', label: 'Tough Case 2n1 - iPhone 16e (tgh2n1sb-ip16e-wht)' },
    { sku: 'tgh2n1sb-ip17-wht', label: 'Tough Case 2n1 - iPhone 17 (tgh2n1sb-ip17-wht)' },
    { sku: 'mstgh2n1sb-ip17-wht', label: 'MagSafe Tough Case 2n1 - iPhone 17 (mstgh2n1sb-ip17-wht)' },
    { sku: 'tgh2n1sb-ip17pr-wht', label: 'Tough Case 2n1 - iPhone 17 Pro (tgh2n1sb-ip17pr-wht)' },
    { sku: 'mstgh2n1sb-ip17pr-wht', label: 'MagSafe Tough Case 2n1 - iPhone 17 Pro (mstgh2n1sb-ip17pr-wht)' },
    { sku: 'tgh2n1sb-ip17prm-wht', label: 'Tough Case 2n1 - iPhone 17 Pro Max (tgh2n1sb-ip17prm-wht)' },
    { sku: 'mstgh2n1sb-ip17prm-wht', label: 'MagSafe Tough Case 2n1 - iPhone 17 Pro Max (mstgh2n1sb-ip17prm-wht)' },
    { sku: 'tgh2n1sb-ip17a-wht', label: 'Tough Case 2n1 - iPhone 17 Air (tgh2n1sb-ip17a-wht)' },
    { sku: 'mstgh2n1sb-ip17a-wht', label: 'MagSafe Tough Case 2n1 - iPhone 17 Air (mstgh2n1sb-ip17a-wht)' },
    { sku: 'tgh2n1sb-ip17e-wht', label: 'Tough Case 2n1 - iPhone 17e (tgh2n1sb-ip17e-wht)' },
    { sku: 'tgh2n1sb-ip18pr-wht', label: 'Tough Case 2n1 - iPhone 18 Pro (tgh2n1sb-ip18pr-wht)' },
    { sku: 'mstgh2n1sb-18pr-wht', label: 'MagSafe Tough Case 2n1 - iPhone 18 Pro (mstgh2n1sb-18pr-wht)' },
    { sku: 'tgh2n1sb-ip18prm-wht', label: 'Tough Case 2n1 - iPhone 18 Pro Max (tgh2n1sb-ip18prm-wht)' },
    { sku: 'mstgh2n1sb-ip18prm-wht', label: 'MagSafe Tough Case 2n1 - iPhone 18 Pro Max (mstgh2n1sb-ip18prm-wht)' },
    { sku: 'tgh2n1sb-ip8-wht', label: 'Tough Case 2n1 - iPhone 8 (tgh2n1sb-ip8-wht)' },
    { sku: 'tgh2n1sb-ip8pl-wht', label: 'Tough Case 2n1 - iPhone 8 Plus (tgh2n1sb-ip8pl-wht)' },
    { sku: 'tgh2n1sb-ip7-wht', label: 'Tough Case 2n1 - iPhone 7 (tgh2n1sb-ip7-wht)' },
    { sku: 'tgh2n1sb-ip7pl-wht', label: 'Tough Case 2n1 - iPhone 7 Plus (tgh2n1sb-ip7pl-wht)' },
    { sku: 'tgh2n1sb-ipxr-wht', label: 'Tough Case 2n1 - iPhone XR (tgh2n1sb-ipxr-wht)' },
    { sku: 'tgh2n1sb-ipx-wht', label: 'Tough Case 2n1 - iPhone X/XS (tgh2n1sb-ipx-wht)' },
    { sku: 'tgh2n1sb-ipxs-wht', label: 'Tough Case 2n1 - iPhone X/XS (tgh2n1sb-ipxs-wht)' },
    { sku: 'tgh2n1sb-ipxsm-wht', label: 'Tough Case 2n1 - iPhone XS Max (tgh2n1sb-ipxsm-wht)' },
    { sku: 'tgh2n1sb-ipse-wht', label: 'Tough Case 2n1 - iPhone SE (tgh2n1sb-ipse-wht)' },
  ];

  loadPrintpossVariants() {
    this.printpossVariants = this.printpossVariantsStatic;
  }

  findPrintpossVariant(sku: string) {
    return this.printpossVariants.find(v => v.sku === sku) ?? null;
  }

  onPrintpossVariantSelected(variant: any) {
    if (!variant) {
      return;
    }
    this.sellerCheck.printpossSku = variant.sku;
    // Variant không có id => 0, để backend bỏ qua id cũ (nếu trước đó chọn variant khác) và resolve theo sku.
    const variantId = variant.id ?? 0;
    this.sellerCheck.printpossVariantId = variantId;
    // Gọi tuần tự: server đọc-sửa-ghi CustomizeInfo, gọi song song sẽ ghi đè nhau (mất Sku hoặc VariantId).
    const orderItemId = this.sellerCheck.sourceProduct.orderItemId;
    this.updateVariantInfo(orderItemId, 'PrintpossSku', variant.sku,
      () => this.updateVariantInfo(orderItemId, 'PrintpossVariantId', variantId));
  }

  // HoGoToPod methods
  loadHoGoToPodProducts() {
    this.hogotopodProductsLoading = true;
    this.fulfillService.getHoGoToPodProducts().subscribe({
      next: (data) => {
        if (data && data.length > 0) {
          this.hogotopodProducts = data;
          console.log('Loaded HoGoToPod products:', this.hogotopodProducts.length);
          
          // Set the selected product if it exists
          if (this.sellerCheck.calculatedHoGoToPodProductCode) {
            this.setSelectedHoGoToPodProduct(this.sellerCheck.calculatedHoGoToPodProductCode);
          }
          
          // Map custom info after products are loaded
          this.mapHoGoToPodCustomInfo();
        }
        this.hogotopodProductsLoading = false;
      },
      error: (error) => {
        console.error('Error loading HoGoToPod products:', error);
        this.hogotopodProductsLoading = false;
        this.toastr.error('Failed to load HoGoToPod products', 'Error');
      }
    });
  }

  onHoGoToPodProductSelected(selectedProduct: any) {
    if (selectedProduct && selectedProduct.code) {
      this.selectedHoGoToPodProduct = selectedProduct;
      this.updateVariantInfo(this.sellerCheck.sourceProduct.orderItemId, 'HoGoToPodProductCode', selectedProduct.code);
      console.log('Selected HoGoToPod product:', selectedProduct.code);
      
      // Update available options based on selected product
      this.updateHoGoToPodAvailableOptions();
    }
  }

  setSelectedHoGoToPodProduct(productCode: string) {
    if (this.hogotopodProducts && this.hogotopodProducts.length > 0) {
      this.selectedHoGoToPodProduct = productCode;
      
      // Update available options when setting selected product
      this.updateHoGoToPodAvailableOptions();
    }
  }

  updateHoGoToPodAvailableOptions() {
    this.availableHoGoToPodColors = [];
    this.availableHoGoToPodSizes = [];
    this.availableHoGoToPodPositions = [];

    if (this.selectedHoGoToPodProduct) {
      // Extract colors
      if (this.selectedHoGoToPodProduct.colors) {
        this.availableHoGoToPodColors = this.selectedHoGoToPodProduct.colors.map(color => ({
          code: color.code,
          name: color.name,
          displayText: `${color.name} (${color.code})`
        }));
      }

      // Extract sizes
      if (this.selectedHoGoToPodProduct.sizeCosts) {
        this.availableHoGoToPodSizes = this.selectedHoGoToPodProduct.sizeCosts.map(size => ({
          size: size.size,
          displayText: size.size
        }));
      }

      // Extract positions
      if (this.selectedHoGoToPodProduct.positions) {
        this.availableHoGoToPodPositions = this.selectedHoGoToPodProduct.positions.map(position => ({
          code: position.code,
          name: position.name,
          displayText: `${position.name} (${position.code})`
        }));
      }

      console.log('Updated HoGoToPod available options:', {
        colors: this.availableHoGoToPodColors.length,
        sizes: this.availableHoGoToPodSizes.length,
        positions: this.availableHoGoToPodPositions.length
      });
    }
  }

  onHoGoToPodColorSelected(selectedColor: any) {
    if (selectedColor) {
      this.updateVariantInfo(this.sellerCheck.sourceProduct.orderItemId, 'HoGoToPodColorCode', selectedColor.code);
      console.log('Selected HoGoToPod color:', selectedColor);
    }
  }

  onHoGoToPodSizeSelected(selectedSize: any) {
    if (selectedSize) {
      this.updateVariantInfo(this.sellerCheck.sourceProduct.orderItemId, 'HoGoToPodSize', selectedSize.size);
      console.log('Selected HoGoToPod size:', selectedSize);
    }
  }

  onHoGoToPodPositionSelected(selectedPosition: any) {
    if (selectedPosition) {
      this.updateVariantInfo(this.sellerCheck.sourceProduct.orderItemId, 'HoGoToPodPositionCode', selectedPosition.code);
      console.log('Selected HoGoToPod position:', selectedPosition);
    }
  }

  mapHoGoToPodCustomInfo() {
    // Map custom info values to component properties
    if (this.sellerCheck.sourceProduct.customizeInfo) {
      const customInfo = this.sellerCheck.sourceProduct.customizeInfo;
      
      // Map product code
      if (customInfo.HoGoToPodProductCode) {
        this.sellerCheck.calculatedHoGoToPodProductCode = customInfo.HoGoToPodProductCode;
      }
      
      // Map color code
      if (customInfo.HoGoToPodColorCode) {
        this.sellerCheck.calculatedHoGoToPodColorCode = customInfo.HoGoToPodColorCode;
      }
      
      // Map size
      if (customInfo.HoGoToPodSize) {
        this.sellerCheck.calculatedHoGoToPodSize = customInfo.HoGoToPodSize;
      }
      
      // Map position code
      if (customInfo.HoGoToPodPositionCode) {
        this.sellerCheck.calculatedHoGoToPodPositionCode = customInfo.HoGoToPodPositionCode;
      }
      
      // Map product type
      if (customInfo.HoGoToPodProductType) {
        this.sellerCheck.calculatedHoGoToPodProductType = customInfo.HoGoToPodProductType;
      }
      
      console.log('Mapped HoGoToPod custom info:', {
        productCode: this.sellerCheck.calculatedHoGoToPodProductCode,
        colorCode: this.sellerCheck.calculatedHoGoToPodColorCode,
        size: this.sellerCheck.calculatedHoGoToPodSize,
        positionCode: this.sellerCheck.calculatedHoGoToPodPositionCode,
        productType: this.sellerCheck.calculatedHoGoToPodProductType
      });
    }
  }

  getBlueprints() {
    this.fulfillService.getBlueprints().subscribe(data => { 
      this.blueprints = data;
    });
  }

  getGearmentProducts() {
    this.fulfillService.getGearmentProducts().subscribe(data => { 
      this.gearmentProducts = data;
    });
  }

  getPrintifyProviders() {
    this.fulfillService.getPrintifyProviders().subscribe(data => { 
      this.printifyProviders = data;
    });
  }

  buyFlashshipByApi() {
    this.global.pageLoading = true;
    this.sellerCheck.currentRecord.isSelected = true;
    this.fulfillService.sendOrderFlashshipApi([this.sellerCheck.currentRecord]).subscribe(data => {
        this.toastr.success('Đặt hàng thành công');
        this.refreshSaleRecordData(data);
        this.modalService.dismissAll();
        this.global.pageLoading = false;
      },
      error => {
        this.toastr.error(error.message);
        this.global.pageLoading = false;
      });
  }

  sendOrderOnosApi() {
    this.global.pageLoading = true;
    this.sellerCheck.currentRecord.isSelected = true;
    this.fulfillService.sendOrderOnosApi([this.sellerCheck.currentRecord]).subscribe(data => {
        this.toastr.success('Đặt hàng thành công');
        this.refreshSaleRecordData(data);
        this.modalService.dismissAll();
        this.global.pageLoading = false;
      },
      error => {
        this.toastr.error(error.message);
        this.global.pageLoading = false;
      });
  }

  sendOrderIsoApi() {
    this.global.pageLoading = true;
    this.sellerCheck.currentRecord.isSelected = true;
    this.fulfillService.sendOrderIsoApi([this.sellerCheck.currentRecord]).subscribe(data => {
        this.toastr.success('Đặt hàng thành công');
        this.refreshSaleRecordData(data);
        this.modalService.dismissAll();
        this.global.pageLoading = false;
      },
      error => {
        this.toastr.error(error.message);
        this.global.pageLoading = false;
      });
  }

  sendOrderPrintpossApi() {
    this.global.pageLoading = true;
    this.sellerCheck.currentRecord.isSelected = true;
    this.fulfillService.sendOrderPrintpossApi([this.sellerCheck.currentRecord]).subscribe(data => {
        this.toastr.success('Đặt hàng thành công');
        this.refreshSaleRecordData(data);
        this.modalService.dismissAll();
        this.global.pageLoading = false;
      },
      error => {
        this.toastr.error(error.message);
        this.global.pageLoading = false;
      });
  }

  sendOrderAtdApi() {
    this.global.pageLoading = true;
    this.sellerCheck.currentRecord.isSelected = true;
    this.fulfillService.sendOrderAtdApi([this.sellerCheck.currentRecord]).subscribe(data => {
        this.toastr.success('Đặt hàng thành công');
        this.refreshSaleRecordData(data);
        this.modalService.dismissAll();
        this.global.pageLoading = false;
      },
      error => {
        this.toastr.error(error.message);
        this.global.pageLoading = false;
      });
  }

  sendOrderGearmentApi() {
    this.global.pageLoading = true;
    this.sellerCheck.currentRecord.isSelected = true;
    this.fulfillService.sendOrderGearmentApi([this.sellerCheck.currentRecord]).subscribe(data => {
        this.toastr.success('Đặt hàng thành công');
        this.refreshSaleRecordData(data);
        this.modalService.dismissAll();
        this.global.pageLoading = false;
      },
      error => {
        this.toastr.error(error.message);
        this.global.pageLoading = false;
      });
  }

  sendOrderZenithApi() {
    this.global.pageLoading = true;
    this.sellerCheck.currentRecord.isSelected = true;
    this.fulfillService.sendOrderZenithApi([this.sellerCheck.currentRecord]).subscribe(data => {
        this.toastr.success('Đặt hàng thành công');
        this.refreshSaleRecordData(data);
        this.modalService.dismissAll();
        this.global.pageLoading = false;
      },
      error => {
        this.toastr.error(error.message);
        this.global.pageLoading = false;
      });
  }

  sendOrderTeroApi() {
    this.global.pageLoading = true;
    this.sellerCheck.currentRecord.isSelected = true;
    this.fulfillService.sendOrderTeroApi([this.sellerCheck.currentRecord]).subscribe(data => {
        this.toastr.success('Đặt hàng thành công');
        this.refreshSaleRecordData(data);
        this.modalService.dismissAll();
        this.global.pageLoading = false;
      },
      error => {
        this.toastr.error(error.message);
        this.global.pageLoading = false;
      });
  }

  sendOrderVtpApi() {
    this.global.pageLoading = true;
    this.sellerCheck.currentRecord.isSelected = true;
    this.fulfillService.sendOrderVtpApi([this.sellerCheck.currentRecord]).subscribe(data => {
        this.toastr.success('Đặt hàng thành công');
        this.refreshSaleRecordData(data);
        this.modalService.dismissAll();
        this.global.pageLoading = false;
      },
      error => {
        this.toastr.error(error.message);
        this.global.pageLoading = false;
      });
  }

  sendOrderHoGoToPodApi() {
    this.global.pageLoading = true;
    this.sellerCheck.currentRecord.isSelected = true;
    this.fulfillService.sendOrderHoGoToPodApi([this.sellerCheck.currentRecord]).subscribe(data => {
        this.toastr.success('Đặt hàng thành công');
        this.refreshSaleRecordData(data);
        this.modalService.dismissAll();
        this.global.pageLoading = false;
      },
      error => {
        this.toastr.error(error.message);
        this.global.pageLoading = false;
      });
  }

  buyPrintifyByApi() {
    this.global.pageLoading = true;
    this.sellerCheck.currentRecord.isSelected = true;
    this.fulfillService.sendOrderPrintifyApi([this.sellerCheck.currentRecord]).subscribe(data => {
        this.toastr.success('Đặt hàng thành công');
        this.refreshSaleRecordData(data);
        this.modalService.dismissAll();
        this.global.pageLoading = false;
      },
      error => {
        this.toastr.error(error.message);
        this.global.pageLoading = false;
      });
  }

  buyPrintCareByApi() {
    this.global.pageLoading = true;
    this.sellerCheck.currentRecord.isSelected = true;
    this.fulfillService.sendOrderBestPrintCareApi([this.sellerCheck.currentRecord]).subscribe(data => {
        this.toastr.success('Đặt hàng thành công');
        this.refreshSaleRecordData(data);
        this.modalService.dismissAll();
        this.global.pageLoading = false;
      },
      error => {
        this.toastr.error(error.message);
        this.global.pageLoading = false;
      });
  }

  sendOrderHdStickerApi() {
    this.global.pageLoading = true;
    this.sellerCheck.currentRecord.isSelected = true;
    this.fulfillService.sendOrderHdStickerApi([this.sellerCheck.currentRecord]).subscribe(data => {
        this.toastr.success('Đặt hàng thành công');
        this.refreshSaleRecordData(data);
        this.modalService.dismissAll();
        this.global.pageLoading = false;
      },
      error => {
        this.toastr.error(error.message);
        this.global.pageLoading = false;
      });
  }

  updateGearmentProduct() {
    var product = this.gearmentProducts.find(i => i.product_id == this.sellerCheck.calculatedGearmentProductId);

    this.gearmentVariants = product.variants;

    this.updateVariantInfo(this.sellerCheck.sourceProduct.orderItemId,
      'gearment_product_id',
      this.sellerCheck.calculatedGearmentProductId);
  }


  setupZenithProducts() {
    this.zenithProducts = zenithProductsData;
  }

  onInventoryOutput(event, record) {
    this.inventoryOutputLoading = true;
    this.inventoryOutputError = '';
    this.inventoryService.outputProduct({
      ProductId: event.productId,
      Number: event.quantity,
      Note: event.orderItemId,
      Reference: event.orderItemId
    }).subscribe({
      next: () => {
        this.inventoryOutputLoading = false;
        // Optionally reload inventoryProducts or show success
      },
      error: (err) => {
        this.inventoryOutputLoading = false;
        this.inventoryOutputError = err?.error || 'Lỗi xuất kho';
      }
    });
  }

  onInventoryOutputDelete(event) {
    this.inventoryOutputLoading = true;
    this.inventoryOutputError = '';
    this.inventoryService.deleteOutputProduct(event.productId, event.orderItemId).subscribe({
      next: () => {
        this.inventoryOutputLoading = false;
        // Optionally reload inventoryProducts or show success
      },
      error: (err) => {
        this.inventoryOutputLoading = false;
        this.inventoryOutputError = err?.error || 'Lỗi xóa xuất kho';
      }
    });
  }

  //Seller Check => End
}
